/* unplugin-vue-components disabled */import script from "./Download.vue?vue&type=script&setup=true&lang=ts"
export * from "./Download.vue?vue&type=script&setup=true&lang=ts"

import "./Download.vue?vue&type=style&index=0&id=bca8dc0a&lang=less"

const __exports__ = script;

export default __exports__